module.exports = __webpack_public_path__ + "img/漯河市.d0a2e3bc.png";